// Components/PayPal/PaymentCancel.tsx
import React from 'react';

const PaymentCancel: React.FC = () => {
    return (
        <div style={{ padding: '2rem' }}>
            <h2>Payment Cancelled</h2>
            <p>You cancelled the payment. If this was a mistake, feel free to try again.</p>
        </div>
    );
};

export default PaymentCancel;
